/**
 * Zeek log field definitions and column configurations
 * Used by ZeekLogsTable and LogTypesSidebar components
 */

export const ZEEK_LOG_FIELDS = {
  conn: {
    fields: ['ts', 'uid', 'id.orig_h', 'id.orig_p', 'id.resp_h', 'id.resp_p', 'proto', 'service', 'duration', 'orig_bytes', 'resp_bytes', 'conn_state'],
    columns: [
      { key: 'ts', label: 'Timestamp', width: 180 },
      { key: 'id.orig_h', label: 'Orig Host', width: 140 },
      { key: 'id.orig_p', label: 'Orig Port', width: 80 },
      { key: 'id.resp_h', label: 'Resp Host', width: 140 },
      { key: 'id.resp_p', label: 'Resp Port', width: 80 },
      { key: 'proto', label: 'Proto', width: 60 },
      { key: 'service', label: 'Service', width: 100 },
      { key: 'duration', label: 'Duration', width: 90 },
      { key: 'orig_bytes', label: 'Orig Bytes', width: 100 },
      { key: 'resp_bytes', label: 'Resp Bytes', width: 100 },
      { key: 'conn_state', label: 'State', width: 80 },
    ]
  },
  dns: {
    fields: ['ts', 'uid', 'id.orig_h', 'id.orig_p', 'id.resp_h', 'id.resp_p', 'query', 'qtype_name', 'rcode_name', 'answers', 'TTLs'],
    columns: [
      { key: 'ts', label: 'Timestamp', width: 180 },
      { key: 'id.orig_h', label: 'Orig Host', width: 140 },
      { key: 'id.orig_p', label: 'Orig Port', width: 80 },
      { key: 'id.resp_h', label: 'Resp Host', width: 140 },
      { key: 'id.resp_p', label: 'Resp Port', width: 80 },
      { key: 'query', label: 'Query', width: 250 },
      { key: 'qtype_name', label: 'Type', width: 80 },
      { key: 'rcode_name', label: 'RCode', width: 100 },
      { key: 'answers', label: 'Answers', width: 200 },
    ]
  },
  http: {
    fields: ['ts', 'uid', 'id.orig_h', 'id.orig_p', 'id.resp_h', 'id.resp_p', 'method', 'host', 'uri', 'status_code', 'user_agent', 'resp_mime_types'],
    columns: [
      { key: 'ts', label: 'Timestamp', width: 180 },
      { key: 'id.orig_h', label: 'Orig Host', width: 140 },
      { key: 'id.orig_p', label: 'Orig Port', width: 80 },
      { key: 'id.resp_h', label: 'Resp Host', width: 140 },
      { key: 'id.resp_p', label: 'Resp Port', width: 80 },
      { key: 'method', label: 'Method', width: 70 },
      { key: 'host', label: 'Host', width: 200 },
      { key: 'uri', label: 'URI', width: 300 },
      { key: 'status_code', label: 'Status', width: 70 },
      { key: 'user_agent', label: 'User Agent', width: 250 },
    ]
  },
  ssl: {
    fields: ['ts', 'uid', 'id.orig_h', 'id.orig_p', 'id.resp_h', 'id.resp_p', 'version', 'cipher', 'server_name', 'established', 'cert_chain_fps'],
    columns: [
      { key: 'ts', label: 'Timestamp', width: 180 },
      { key: 'id.orig_h', label: 'Orig Host', width: 140 },
      { key: 'id.orig_p', label: 'Orig Port', width: 80 },
      { key: 'id.resp_h', label: 'Resp Host', width: 140 },
      { key: 'id.resp_p', label: 'Resp Port', width: 80 },
      { key: 'server_name', label: 'Server Name', width: 200 },
      { key: 'version', label: 'Version', width: 80 },
      { key: 'cipher', label: 'Cipher', width: 200 },
      { key: 'established', label: 'Established', width: 90 },
    ]
  },
  files: {
    fields: ['ts', 'uid', 'source', 'filename', 'mime_type', 'total_bytes', 'md5', 'sha1', 'sha256'],
    columns: [
      { key: 'ts', label: 'Timestamp', width: 180 },
      { key: 'source', label: 'Source', width: 100 },
      { key: 'filename', label: 'Filename', width: 200 },
      { key: 'mime_type', label: 'MIME Type', width: 150 },
      { key: 'total_bytes', label: 'Size', width: 100 },
      { key: 'sha256', label: 'SHA256', width: 300 },
    ]
  },
  x509: {
    fields: ['ts', 'certificate.version', 'certificate.serial', 'certificate.subject', 'certificate.issuer', 'certificate.not_valid_before', 'certificate.not_valid_after'],
    columns: [
      { key: 'ts', label: 'Timestamp', width: 180 },
      { key: 'certificate.subject', label: 'Subject', width: 300 },
      { key: 'certificate.issuer', label: 'Issuer', width: 300 },
      { key: 'certificate.not_valid_before', label: 'Valid From', width: 150 },
      { key: 'certificate.not_valid_after', label: 'Valid Until', width: 150 },
    ]
  },
  weird: {
    fields: ['ts', 'uid', 'id.orig_h', 'id.orig_p', 'id.resp_h', 'id.resp_p', 'name', 'notice', 'peer'],
    columns: [
      { key: 'ts', label: 'Timestamp', width: 180 },
      { key: 'id.orig_h', label: 'Orig Host', width: 140 },
      { key: 'id.orig_p', label: 'Orig Port', width: 80 },
      { key: 'id.resp_h', label: 'Resp Host', width: 140 },
      { key: 'id.resp_p', label: 'Resp Port', width: 80 },
      { key: 'name', label: 'Name', width: 200 },
      { key: 'notice', label: 'Notice', width: 100 },
      { key: 'peer', label: 'Peer', width: 150 },
    ]
  },
  notice: {
    fields: ['ts', 'uid', 'id.orig_h', 'id.orig_p', 'id.resp_h', 'id.resp_p', 'note', 'msg', 'sub', 'actions'],
    columns: [
      { key: 'ts', label: 'Timestamp', width: 180 },
      { key: 'id.orig_h', label: 'Orig Host', width: 140 },
      { key: 'id.orig_p', label: 'Orig Port', width: 80 },
      { key: 'id.resp_h', label: 'Resp Host', width: 140 },
      { key: 'id.resp_p', label: 'Resp Port', width: 80 },
      { key: 'note', label: 'Note', width: 200 },
      { key: 'msg', label: 'Message', width: 300 },
      { key: 'actions', label: 'Actions', width: 150 },
    ]
  },
  smtp: {
    fields: ['ts', 'uid', 'id.orig_h', 'id.orig_p', 'id.resp_h', 'id.resp_p', 'mailfrom', 'rcptto', 'subject', 'from', 'to'],
    columns: [
      { key: 'ts', label: 'Timestamp', width: 180 },
      { key: 'id.orig_h', label: 'Orig Host', width: 140 },
      { key: 'id.orig_p', label: 'Orig Port', width: 80 },
      { key: 'id.resp_h', label: 'Resp Host', width: 140 },
      { key: 'id.resp_p', label: 'Resp Port', width: 80 },
      { key: 'mailfrom', label: 'Mail From', width: 200 },
      { key: 'rcptto', label: 'Rcpt To', width: 200 },
      { key: 'subject', label: 'Subject', width: 300 },
    ]
  },
  ssh: {
    fields: ['ts', 'uid', 'id.orig_h', 'id.orig_p', 'id.resp_h', 'id.resp_p', 'version', 'auth_success', 'auth_attempts', 'client', 'server'],
    columns: [
      { key: 'ts', label: 'Timestamp', width: 180 },
      { key: 'id.orig_h', label: 'Orig Host', width: 140 },
      { key: 'id.orig_p', label: 'Orig Port', width: 80 },
      { key: 'id.resp_h', label: 'Resp Host', width: 140 },
      { key: 'id.resp_p', label: 'Resp Port', width: 80 },
      { key: 'auth_success', label: 'Auth Success', width: 100 },
      { key: 'client', label: 'Client', width: 200 },
      { key: 'server', label: 'Server', width: 200 },
    ]
  }
}

// Fallback columns for unknown log types
export const DEFAULT_COLUMNS = [
  { key: 'ts', label: 'Timestamp', width: 180 },
  { key: '_raw', label: 'Document', width: null } // null = flex
]

/**
 * Get column definitions for a specific log type
 * @param {string} logType - The zeek log type (conn, dns, http, etc.)
 * @returns {Array} Column definitions
 */
export function getColumnsForLogType(logType) {
  return ZEEK_LOG_FIELDS[logType]?.columns || DEFAULT_COLUMNS
}

/**
 * Get field names for a specific log type
 * @param {string} logType - The zeek log type
 * @returns {Array} Field names
 */
export function getFieldsForLogType(logType) {
  return ZEEK_LOG_FIELDS[logType]?.fields || []
}

/**
 * Check if a log type has defined fields
 * @param {string} logType - The zeek log type
 * @returns {boolean}
 */
export function hasFieldsForLogType(logType) {
  return ZEEK_LOG_FIELDS[logType]?.fields?.length > 0
}

/**
 * Get column config for a specific field in a log type
 * @param {string} logType - The zeek log type
 * @param {string} fieldKey - The field key (e.g., 'id.orig_h')
 * @returns {Object|null} Column config with label/width, or null if not configured
 */
export function getColumnConfig(logType, fieldKey) {
  const config = ZEEK_LOG_FIELDS[logType]?.columns?.find(c => c.key === fieldKey)
  return config || null
}

/**
 * Get the configured field order for a log type
 * @param {string} logType - The zeek log type
 * @returns {string[]} Array of field keys in their configured display order
 */
export function getConfiguredFieldOrder(logType) {
  return ZEEK_LOG_FIELDS[logType]?.columns?.map(c => c.key) || []
}

/**
 * Get default column width based on field name patterns
 * @param {string} key - The field key
 * @returns {number} Width in pixels
 */
export function getDefaultColumnWidth(key) {
  if (key === 'ts') return 180
  if (key.includes('_h') || key.endsWith('.h')) return 140  // IP hosts
  if (key.includes('_p') || key.endsWith('.p')) return 80   // Ports
  if (key.includes('bytes')) return 100
  if (key === 'duration') return 90
  if (key === 'uid') return 180
  return 150  // Default for unknown fields
}
